export const NamespaceToCountry = {
  // united states
  "northfield": "US",
  "northfieldCedarDownsOTB": "US",
  "monmouth": "US",
  "yonkers": "US",
  "morgantownOTB": "US",
  "yorkOTB": "US",
  "bangor": "US",
  "plainridge": "US",
  "suffolkOTB": "US",
  "hawthornecwoodOTB": "US",
  "monmouthwbridgeOTB": "US",
  "bowlingGreen": "US",
  "williamsburg": "US",
  "cumberlandRun": "US",
  "runningAces": "US",
  "sanfordOrlando": "US",
  "dayton": "US",
  "pennNational": "US",
  "tristate": "US",
  "glouchester": "US",
  "charlestown": "US",
  "emerald": "US",
  "mahoning": "US",
  "samHouston": "US",
  "wildrose": "US",
  "pocono": "US",
  "poconoAllentownOTB": "US",
  "tucson2023": "US",
  "catskill": "US",
  "meadowlands": "US",
  "zia": "US",
  "delaware": "US",
  "hawthorne": "US",
  "hawthorneJolietOTB": "US",
  "hawthorneHoffmanEstatesOTB": "US",
  "hawthorneAuroraOTB": "US",
  "hawthorneEvergreenOTB": "US",
  "hawthorneMokenaOTB": "US",
  "hawthorneRockfordOTB": "US",
  "hawthorneProspectHeightsOTB": "US",
  "hawthorneOakbrookOTB": "US",
  "hawthorneMcHenryOTB": "US",
  "hawthorneVillaParkOTB": "US",
  "moheganSun" : "US",
  "deltaDowns": "US",
  "evangelineDowns": "US",
  "parx": "US",
  "southPhillyOTB": "US",
  "catskillsOTB": "US",
  "freehold": "US",
  "tomsRiver": "US",
  "bayonneOTB": "US",
  "miamiWilliamHill": "US",
  "borgata": "US",
  "lansing": "US",
  "raynham": "US",
  "nassau" : "US",
  "loneStar" : "US",
  "sarasota": "US",
  

  // malaysia
  "selangor": "MY",
  "perakTurfClub" : "MY",


  // caymanas
  "caymanas": "JM",

  "camarero": "PR",

  "chile": "CL",
  "chileClubHipico": "CL",
  "chileHipodromo": "CL",
  "chileTeletrakOTB": "CL",
  // australia
  "bm-lfi": "AU",
  "default": "AU",
  "sensu-system": "AU",
  "factoryDefault": "AU",
  "testing": "AU"
}

export const NamespaceToFormattedName = {
  // united states
  "northfield": "Northfield",
  "northfieldCedarDownsOTB": "Cedar Downs OTB",
  "monmouth": "Monmouth",
  "yonkers": "Yonkers",
  "morgantownOTB": "Morgantown OTB",
  "yorkOTB": "York OTB",
  "bangor": "Bangor",
  "plainridge": "Plainridge",
  "suffolkOTB": "Suffolk OTB",
  "hawthornecwoodOTB": "Crestwood OTB",
  "monmouthwbridgeOTB": "Woodbridge OTB",
  "bowlingGreen": "Bowling Green OTB",
  "williamsburg": "Williamsburg",
  "cumberlandRun": "Cumberland Run",
  "runningAces": "Running Aces",
  "sanfordOrlando": "Sanford Orlando OTB",
  "dayton": "Dayton",
  "pennNational": "Penn National",
  "tristate": "Tri-State",
  "glouchester": "Glouchester OTB",
  "charlestown": "Charles Town",
  "emerald": "Emerald Downs",
  "mahoning": "Mahoning",
  "samHouston": "Sam Houston",
  "wildrose": "Wildrose Clinton",
  "pocono": "Pocono",
  "poconoAllentownOTB": "Allentown OTB",
  "tucson2023": "Tucson 2023",
  "catskill": "Catskill",
  "meadowlands": "Meadowlands",
  "zia": "Zia Park",
  "delaware": "Delaware Park",
  "hawthorne": "Hawthorne",
  "hawthorneJolietOTB": "Joliet OTB",
  "hawthorneHoffmanEstatesOTB": "Hoffman Estates OTB",
  "hawthorneAuroraOTB": "North Aurora OTB",
  "hawthorneEvergreenOTB": "Evergreen OTB",
  "hawthorneMokenaOTB": "Mokena OTB",
  "hawthorneRockfordOTB": "Rockford OTB",
  "hawthorneProspectHeightsOTB": "Prospect Heights OTB",
  "hawthorneOakbrookOTB": "Oakbrook OTB",
  "hawthorneMcHenryOTB": "McHenry OTB",
  "hawthorneVillaParkOTB": "Villa Park OTB",
  "moheganSun" : "Mohegan Sun",
  "deltaDowns": "Delta Downs",
  "evangelineDowns": "Evangeline Downs",
  "parx": "Parx",
  "southPhillyOTB": "South Philly OTB",
  "catskillsOTB": "Catskills OTB",
  "freehold": "Freehold",
  "tomsRiver": "Toms River",
  "bayonneOTB": "Bayonne OTB",
  "miamiWilliamHill": "Miami William Hill",
  "borgata": "Borgata",
  "lansing": "Lansing",
  "raynham": "Raynham",
  "nassau" : "Nassau",
  "loneStar" : "Lone Star",
  "sarasota": "Sarasota",
  // malaysia
  "selangor": "Selangor",
  "perakTurfClub" : "Perak Turf Club",

  // caymanas
  "caymanas": "Caymanas",

  // Puerto Rico
  "camarero": "Camarero",

  // chile
  "chile": "Chile",
  "chileTeletrakOTB": "Teletrak OTBs",
  "chileHipodromo": "Hipodromo",
  "chileClubHipico": "Club Hipico",



  // australia
  "bm-lfi": "BetMakers LFI",
  "default": "Default",
  "sensu-system": "Sensu System",
  "factoryDefault": "Factory Default",
  "testing": "Testing"
}

export function getFormattedName(namespace: string) {
  return NamespaceToFormattedName?.[namespace] || namespace;
}

export function getFormattedCountry(namespace: string) {
  return NamespaceToCountry?.[namespace] || namespace;
}
